const pad = (value: number): string => value.toString().padStart(2, "0");

// Секунды → "ЧЧ:ММ:СС"; розыгрыш длится максимум 24ч.
export const formatTimeLeft = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};
